import React from 'react';
import { StyledTooltip, StyledMobileTooltip } from './styles';

interface ITooltip {
  title?: string;
  titleArray?: string[];
  children: React.ReactNode;
  mobile?: boolean;
  childrenHeight?: string;
}

const getTitle = (titleArray: string[]) => {
  if (titleArray.length <= 1) {
    return titleArray[0];
  }
  return (
    <div>
      {titleArray.map((item) => (
        <li style={{ marginLeft: '10px' }}>{item}</li>
      ))}
    </div>
  );
};

const Tooltip = ({
  title = '',
  titleArray,
  children,
  mobile = false,
  childrenHeight = '20px',
}: ITooltip) =>
  mobile ? (
    <>
      <StyledMobileTooltip>{titleArray ? getTitle(titleArray) : title}</StyledMobileTooltip>
      <div style={{ height: childrenHeight }}>{children}</div>
    </>
  ) : (
    <StyledTooltip
      title={titleArray ? getTitle(titleArray) : title}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: '#082a4a',
            fontWeight: 400,
            padding: '5px 15px',
            fontSize: '0.75rem',
            lineHeight: '1rem',
            maxWidth: '500px',
          },
        },
      }}
    >
      <div style={{ height: childrenHeight }}>{children}</div>
    </StyledTooltip>
  );

export default Tooltip;
